import React, { useRef, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { MapContainer, TileLayer, Marker } from "react-leaflet";

export default function LocationInput(props) {
    const { latitudeSource, longitudeSource } = props;

    const [parkingLatitude, setParkingLatitude] = useState(latitudeSource)
    const [parkingLongitude, setParkingLongitude] = useState(longitudeSource)

    const markerRef = useRef(null);

    const coordinate = [parkingLatitude, parkingLongitude];

    const eventHandlers = useMemo(() => ({
        dragend() {
            const marker = markerRef.current
            if (marker != null) {
                const latlng = marker.getLatLng();
                console.log(latlng);
                setParkingLatitude(latlng.lat);
                setParkingLongitude(latlng.lng);
            }
        }
    }), []); // eslint-disable-line react-hooks/exhaustive-deps

    return (<>
        <Helmet>
            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin="" />
        </Helmet>

        <MapContainer
            center={coordinate}
            zoom={15}
            scrollWheelZoom={true}
            style={{ width: "100%", height: "100%", marginTop: 20 }}

        >
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
                ref={markerRef}
                position={coordinate}
                eventHandlers={eventHandlers}
            />
        </MapContainer>
    </>);
};